import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'outline';
  isLoading?: boolean;
}

const Button = ({
  children,
  variant = 'primary',
  isLoading = false,
  disabled,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) => {
  const baseClasses =
    'btn btn-lg w-100 fw-semibold d-flex align-items-center justify-content-center gap-2';
  const variantClasses =
    variant === 'primary'
      ? 'btn-primary nova-btn'
      : 'btn-outline-primary nova-btn-outline';

  return (
    <button
      type={type}
      className={`${baseClasses} ${variantClasses} ${className}`}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...rest}
    >
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </button>
  );
};

export default Button;
